import { Injectable, Pipe, PipeTransform  } from '@angular/core';
import { DatePipe } from '@angular/common'

@Injectable()
@Pipe({
    name: 'dateFormatPipe',
})
export class DateFormatPipe implements PipeTransform {
    transform(value: string) {
        var datePipe = new DatePipe("en-US");
        value = datePipe.transform(value, 'MM/dd/yyyy');
        return value;
    }
}


@Injectable()
@Pipe({
        name: 'dateFPipe'
})
export class dateFPipe {
    transform(val) {
        var viewVal = val.trim().replace(/^\+/, '');
        viewVal = viewVal.replace(/[^0-9]/g, '').slice(0, 10);
        var month, number;
        switch (viewVal.length) {
            case 1:
            case 2:
                month = viewVal;
                break; 
            default:
                month = viewVal.slice(0, 2);
                number = viewVal.slice(2);
        }
        if (number) {
            if (number.length > 2) {
                number = number.slice(0, 2) + '/' + number.slice(2, 6);
            }
            else {
                number = number;
            }
            return (month + "/" + number).trim().slice(0, 10);
        }
        else {
            return viewVal;
        }
    }
}

@Injectable()
@Pipe({
    name: 'CurrentDateToUtcDate'
})
export class CurrentDateToUtcDate {

    transform(date: Date, time: any) {
        let timeHH = parseInt(time.toString().replace(':','').slice(0, 2));
        let timeMM = parseInt(time.toString().replace(':', '').slice(2, 4));

        let utcDate: Date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), timeHH, timeMM);

        return utcDate.toUTCString();
    }
}

@Injectable()
@Pipe({
    name: 'ConvertDateToUTC'
})
export class ConvertDateToUTC{

    transform(date: Date) {
        let utcDate = new Date(Number((new Date(date)).getFullYear().toString()), Number((new Date(date)).getMonth().toString()), Number((new Date(date)).getUTCDate().toString()));
        return utcDate;
    }
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/pipes/dateformat.pipe.ts